import React from 'react';
import loadable from '@loadable/component';
import campaignPageQuery from './query.graphql';
import type { Props } from './campaign';
import type { MarketCode } from 'config/markets/types';
import type { Campaign as CampaignType } from 'src/types';

const CampaignContent = loadable(
  () => import(/* webpackChunkName: "campaigns" */ './campaign')
);

const Campaign = (props: Props) => <CampaignContent {...props} />;

Campaign.graphQL = campaignPageQuery;

Campaign.loadOrder = [{}];

const FILTER_URL_PARAMS = [
  'category',
  'price',
  'productRating',
  'storeRating',
  'stores',
  'offset',
];

type Variables = {
  category?: string;
  name: string;
  list?: string;
  min_price?: number;
  max_price?: number;
  sort: string;
  marketCode: MarketCode;
  experiments: {
    [key in keyof string]: {
      name: string;
      optimizeId: string;
      selectedVariant: string;
      shouldCache: boolean;
      variantIndex: number;
    };
  };
};

Campaign.variables = ({
  name,
  list: listSlug,
  min_price: minPrice,
  max_price: maxPrice,
  ...variables
}: Variables) => {
  return {
    id: /^\d+$/.test(name) ? parseInt(name, 10) : undefined,
    campaignSlug: name,
    listSlug,
    limit: 20,
    minPrice,
    maxPrice,
    filters: FILTER_URL_PARAMS.map(key =>
      variables[key] ? { key, value: variables[key] } : null
    ).filter(Boolean),
    peakIndexCategoryId: variables.category,
    campaignDeals: name === 'black-friday',
  };
};

Campaign.isActive = (campaign: CampaignType) => campaign?.state === 'ACTIVE';

export default Campaign;
